import React from 'react';
import clsx from 'clsx';
import { StyledText, TEXT_BOLD_CLASS, TEXT_CENTER_CLASS, TEXT_ITALIC_CLASS, TEXT_TYPE_CLASS_PREFIX } from './styles';

export const Text = ({ type, bold, italic, center, className, ...props }) => {
  return (
    <StyledText
      className={clsx(
        type && `${TEXT_TYPE_CLASS_PREFIX}${type}`,
        bold && TEXT_BOLD_CLASS,
        italic && TEXT_ITALIC_CLASS,
        center && TEXT_CENTER_CLASS,
        className
      )}
      {...props}
    />
  );
};

export default Text;
